module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAL9JREFUeNpiYBgFwx0wkqtRSlxaH0gJ4FFy4dnLpx9xSbJQ4OgJQOyARfwDEBcALT2ITzMTlUNwARArAC1dSEghC5UsvECML6lt8QEgboDGuz0suIGOuEhrix2glpOUcFmoEcQ4EhhNg/oDKfFKy1Q9avGoxaMWj1qMtwHgT4wY1VsgQEv2A6kHoHoXKvQAWgc7kmIOuWV1ApaqkeZxXIBW+3zAUUNRv7EHbejBfOlAqNKnKgBZDnXAKBjcACDAAKqhMoneWp7SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/12.png
// module id = 767
// module chunks = 0